// Layout.tsx
import { Sidebar } from "./Sidebar";
import { Navbar } from "./Navbar";
import React from "react";
import { useUIStore } from "../store/uiStore";
import { AccessDeniedDialog } from "./AccessDeniedDialog";

interface LayoutProps {
  children: React.ReactNode;
  role: string;
}

export const Layout: React.FC<LayoutProps> = ({ children, role }) => {
  const { isAccessDenied, deniedModule } = useUIStore();
  return (
    <div className="flex bg-bg h-screen overflow-hidden">
      {isAccessDenied && <AccessDeniedDialog moduleName={deniedModule} />}

      <Sidebar role={role} />

      <div
        className={`
          flex flex-col flex-1 
          transition-all duration-300 ease-in-out
          min-w-0
        `}
      >
        <Navbar />
        <main
          className={`flex-1 p-0 md:p-4 lg:p-6 bg-bg text-text overflow-y-auto relative`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};